import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * New Zealand IRD Number validator following Single Responsibility Principle
 */
export class NzValidator extends BaseValidator {
  constructor() {
    super({
      name: 'New Zealand IRD Number',
      pattern: /^\d{8,9}$/,
      minLength: 8,
      maxLength: 9
    });
  }

  validateFormat(id) {
    // Check length
    if (id.length < this.config.minLength || id.length > this.config.maxLength) {
      return ValidationResult.invalid('IRD must be 8 or 9 digits');
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'IRD must contain only digits'
    );
  }

  validateChecksum(id) {
    const weights = [3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;

    for (let i = 0; i < Math.min(id.length - 1, 8); i++) {
      sum += parseInt(id[i]) * weights[i];
    }

    const remainder = sum % 11;
    let expectedChecksum;

    if (remainder === 0) {
      expectedChecksum = 0;
    } else if (remainder === 1) {
      return ValidationResult.invalid('Invalid IRD - remainder cannot be 1');
    } else {
      expectedChecksum = 11 - remainder;
    }

    const actualChecksum = parseInt(id[id.length - 1]);
    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid IRD checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid IRD');
  }
}